export default {
  Action_Logs: "Log Aksi",
  Action_Logs_Data: "Data Log Aksi",
  Admin: "Admin",
  Amount: "Jumlah",
  Amount_must_be_lower_than_current_balance: "Jumlah harus lebih kecil dari saldo saat ini",
  An_Error_Occurred: "Terjadi kesalahan",
  API_Endpoint: "API Endpoint",
  Apply: "Terapkan",
  Arguments: "Argumen",
  Cancel: "Batal",
  Currency: "Mata Uang",
  Custom: "Kustom",
  Custom_Date_Range: "Rentang Tanggal Kustom",
  Date_And_time: "Tanggal & Waktu",
  Date_From: "Tanggal Dari",
  Date_To: "Tanggal Sampai",
  Endpoint: "Titik Akhir",
  Error_500: "Kesalahan 500. Silakan hubungi dukungan melalui tab 'Minta Bantuan'",
  Export: "Ekspor",
  Export_Data: "Ekspor Data",
  Export_Device_Logs: "Ekspor Log Perangkat",
  Exported_file_in_csv_format: "File yang diekspor akan dalam format CSV",
  Fetch_More_Data: "Ambil Lebih Banyak Data",
  From_Date: "Dari Tanggal",
  Inadequate_admin_privilege: "Hak akses admin tidak memadai",
  Last_12hrs: "12 Jam Terakhir",
  Last_24hrs: "24 Jam Terakhir",
  Last_30_days: "30 Hari Terakhir",
  Last_365_days: "365 Hari Terakhir",
  Last_7_days: "7 Hari Terakhir",
  Lookup_Logs: "Cari Log",
  Memo: "Keterangan",
  Money_was_deducted_from_the_wallet: "Uang telah dipotong dari dompet",
  No_refund_on_owner_wallet: "Tidak dapat melakukan refund pada dompet pemilik",
  No_timezone_available: "Zona waktu tidak tersedia",
  Note_you_can_change_the_calendar_date_text: "Catatan: Anda dapat mengubah tanggal kalender dan hasil pencarian untuk menyaring data yang ingin diekspor.",
  PlugzioAdminDashboard: "Dasbor Admin Plugzio",
  PlugzioManagementDashboard: "Dasbor Manajemen Plugzio",
  PlugzioUserDashboard: "Dasbor Pengguna Plugzio",
  Please_provide_amount_greater_than: "Harap masukkan jumlah yang lebih besar dari",
  Or: "Atau",
  Refund: "Pengembalian Dana",
  Refund_Session: "Pengembalian Dana Sesi",
  Regex: "Regex",
  Rows: "Baris",
  Search: "Cari",
  Search_Filter: "Filter Pencarian",
  Search_RegEx: "Pencarian RegEx",
  Session: "Sesi",
  Session_refund_amount_is_too_big: "Jumlah pengembalian terlalu besar",
  Session_successfully_refunded: "Pengembalian dana sesi berhasil",
  This_field_is_required: "Kolom ini wajib diisi",
  Time_Zone: "Zona Waktu",
  Time_Zone_GMT: "Zona Waktu (GMT)",
  Timestamp: "Penanda Waktu",
  Timezone: "Zona Waktu",
  To_Date: "Hingga Tanggal",
  Today: "Hari Ini",
  Total_Rows: "Total Baris",
  Total_Session_Amount: "Total Jumlah Sesi",
  User: "Pengguna",
  Yesterday: "Kemarin",
  DidntSeeDeviceNumber: "Tidak melihat nomor perangkat",
  HowToActivatePlugzio: "Cara mengaktifkan Plugzio",
  StartUsingPlugzioByPluggingInBeforeEnteringPlugNumber:
    'Mulai gunakan Plugzio dengan mencolokkan sebelum memasukkan steker #. Steker # dapat ditemukan di bagian depan perangkat di bawah kode QR. Pada gambar contoh, steker # adalah "XX123" yang dilingkari dengan warna merah',
  StartUsingPlugzioByPluggingAndScanning: "Mulai gunakan Plugzio dengan mencolokkan dan memindai kode QR atau memasukkan nomor perangkat di bawah kode QR.",
  Recent: "Terbaru",
  Favorite: "Favorit",
  Analysis: "Analisis",
  DetailedAnalysisComingSoon: "Analisis terperinci segera hadir",
  NoSessionsYet: "Tidak Ada Sesi yang Ditemukan",
  Scan: "Pindai",
  AtoK0to9AndDotOnly: "A hingga K, 0 hingga 9 dan . saja",
  DeviceHashSymbol: "Simbol perangkat",
  Charge_another_car: "Mengisi daya mobil lain",
  Ready_to_charge_your_car: "Siap mengisi daya mobil Anda",
  Scan_QR_Code_or_enter_device_number: "Pindai Kode QR atau masukkan nomor perangkat",
  Consumption: "Konsumsi",
  Duration: "Durasi",
  Activate: "Aktifkan",
  Device: "Perangkat",
  Last_updated: "Terakhir diperbarui",
  Hi: "Hai",
  Welcome_back: "Selamat datang kembali",
  Good_to_see_you: "Senang bertemu dengan Anda",
  Ongoing: "Sedang berlangsung",
  h: "j",
  m: "m",
  s: "d",
  ago: "yang lalu",
  second: "detik",
  minute: "menit",
  hour: "jam",
  hours: "jam",
  hour_with_value: "{n} jam",
  hours_with_value: "{n} jam",
  minute_with_value: "{n} menit",
  minutes_with_value: "{n} menit",
  sec: "dtk",
  min: "mnt",
  hr: "j",
  Just_now: "Baru saja",
  min_ago: "{n} menit yang lalu",
  End_session: "Selesaikan sesi",
  End_Session: "Selesaikan Sesi",
  Charging: "Mengisi Daya",
  Favorites_are_limited_to_10_devices: "Favorit dibatasi maksimal 10 perangkat",
  No_favorite_devices: "Tidak ada perangkat favorit",
  Number_of_user_sessions: "Jumlah sesi pengguna",
  Total_Kilowatt_hours_consumed: "Total Kilowatt jam yang dikonsumsi",
  Total_time_span_of_all_user_sessions: "Total rentang waktu semua sesi pengguna",
  Edit_favorite_device: "Ubah Perangkat Favorit",
  Retry: "Coba Lagi",
  Submit: "Kirim",
  Description: "Deskripsi",
  Failed_to_update_device_preferences: "Gagal memperbarui preferensi perangkat",
  Please_try_again: "Silakan coba lagi",
  Confirm: "Konfirmasi",
  Do_you_want_to_end_the_session_for: "Apakah Anda ingin mengakhiri sesi untuk",
  This_will_terminate_the_ongoing_session: "Ini akan menghentikan sesi yang sedang berlangsung",
  Terminate_Ongoing_Session: "Akhiri Sesi yang Sedang Berlangsung",
  Stale_Session: "Sesi Basi",
  Charging_session_on_device: "Sesi pengisian daya pada perangkat",
  has_failed_to: "gagal untuk",
  Device_may_be_offline: "Perangkat mungkin sedang offline.",
  Please_try_again_or_contact_customer_support: "Silakan coba lagi atau hubungi layanan pelanggan",
  Charging_Session_Timeout: "Sesi pengisian daya habis waktu",
  Max_Amount: "Jumlah Maksimal",
  Edit_item: "Edit item",
  Edit_Device: "Edit Perangkat",
  Edit_Manager: "Edit Manajer",
  Edit_User: "Edit Pengguna",
  Date: "Tanggal",
  Email: "Email",
  "E-mail": "E-mail",
  User_Does_Not_Exist: "Pengguna Tidak Ada",
  Manager_Does_Not_Exist: "Manajer Tidak Ada",
  Lookup_Managers: "Cari Manajer",
  Lookup_Users: "Cari Pengguna",
  Lookup_Devices: "Cari Perangkat",
  "Enter_Manager_E-mail": "Masukkan E-mail Manajer",
  "Enter_User_E-mail": "Masukkan E-mail Pengguna",
  Searched_Managers: "Manajer yang Dicari",
  Searched_Users: "Pengguna yang Dicari",
  Enter_Device_ID: "Masukkan ID Perangkat",
  Searched_Devices: "Perangkat yang Dicari",
  Device_ID: "ID Perangkat",
  Cannot_favorite_a_previously_unregistered_device: "Tidak dapat menandai perangkat yang pernah dihapus sebagai favorit",
  Activating_the_device: "Mengaktifkan perangkat",
  Insufficient_funds_in_wallet: "Saldo dompet tidak mencukupi",
  Access_to_this_device_is_restricted: "Akses ke perangkat ini dibatasi. Untuk mendapatkan akses, silakan hubungi manajemen.",
  This_device_is_configured_to_deliver_electricity: "Perangkat ini dikonfigurasi untuk menyalurkan listrik saat Anda mencolokkan. Tidak perlu aktivasi!",
  This_device_has_been_disabled_by_management: "Perangkat ini telah dinonaktifkan oleh manajemen. Silakan hubungi manajemen untuk informasi lebih lanjut.",
  Device_not_set_up: 'Perangkat "{plugIdentifier}" belum dikonfigurasi oleh manajemen. Silakan hubungi pengelola properti untuk informasi lebih lanjut.',
  There_is_no_charge_for_using_this_device: "Tidak ada biaya untuk menggunakan perangkat ini",
  No_Wallet_Available: "Tidak ada dompet yang tersedia",
  Wallet_Balance: "Saldo Dompet",
  Creating: "Sedang membuat",
  wallet: "dompet",
  You_do_not_have_a_wallet: "Anda tidak memiliki dompet",
  We_would_like_to_automatically_create_one_for_you: ". Kami akan membuatkannya secara otomatis untuk Anda. Silakan konfirmasi untuk melanjutkan.",
  Set_by: "Diatur oleh",
  company: "perusahaan",
  Set_by_your_property_manager: "Diatur oleh manajer properti Anda",
  Contact: "Kontak",
  Low_Wallet_Balance: "Saldo Dompet Rendah",
  Top_up: "Isi saldo",
  Device_charges_in_currency: "Perangkat ini melakukan pengisian dalam mata uang {currency}. Silakan buat dompet {currency} untuk menggunakan perangkat ini.",
  Failed_to_start_load_balanced_session: "Gagal memulai sesi dengan pembagian beban. Silakan coba lagi nanti.",
  Device_is_offline: "Perangkat sedang offline atau tidak dapat dijangkau",
  Try_Again: "Coba Lagi",
  Create_Wallet: "Buat Dompet",
  TOP_UP: "ISI SALDO",
  Automatically_Start_Sessions: "Mulai Sesi secara Otomatis",
  Would_you_like_to_automatically_start_sessions:
    "Anda adalah satu-satunya pengguna yang berwenang menggunakan perangkat ini. Apakah Anda ingin memulai sesi secara otomatis saat mencolokkan?",
  Learn_About_Automatically_Starting_Sessions: "Pelajari Tentang Memulai Sesi Secara Otomatis",
  I_acknowledge_the_risk: "Saya menyadari risikonya dan ingin mengizinkan sesi dimulai secara otomatis",
  You_have_allowed_sessions_to_automatically_start: "Anda telah mengizinkan sesi dimulai secara otomatis",
  Allow_sessions_to_auto_start: "Izinkan sesi dimulai secara otomatis",
  Back: "Kembali",
  Device_Activation: "Aktivasi Perangkat",
  Automatically_Starting_Sessions: "Memulai Sesi secara Otomatis",
  Enabling_this_feature_keeps_the_Plugzio_device_on: "Mengaktifkan fitur ini akan membuat perangkat Plugzio tetap menyala dan siap digunakan segera.",
  This_allows_sessions_to_automatically_begin: "Ini memungkinkan sesi dimulai secara otomatis begitu Anda mencolokkan perangkat untuk mendapatkan daya.",
  You_will_be_able_to_use_the_Plugzio_device: "Anda akan dapat menggunakan perangkat Plugzio tanpa repot melakukan aktivasi.",
  Manually_stopping_a_session_through_the_dashboard: "Menghentikan sesi secara manual melalui dasbor akan mengharuskan Anda untuk memulai sesi secara manual.",
  RISKS_RESPONSIBILITY: "RISIKO & TANGGUNG JAWAB",
  With_easy_access_comes_less_security:
    "Akses yang mudah berarti keamanan yang lebih rendah, aktivasi otomatis berarti siapa pun dapat mencolokkan dan menggunakan daya dengan biaya Anda.",
  Enabling_sessions_to_automatically_start_means:
    "Mengaktifkan sesi untuk mulai secara otomatis berarti Anda akan bertanggung jawab dan dikenakan biaya atas semua konsumsi perangkat ini tanpa otentikasi dari Anda.",
  You_will_be_billed_at_the_rate: "Anda akan dikenakan biaya sesuai dengan tarif yang ditentukan oleh rencana pembayaran manajer.",
  You_agree_to_automatically_accept_any_payment_plan:
    "Anda setuju untuk secara otomatis menerima rencana pembayaran apa pun yang ditetapkan oleh pengelola perangkat. Menjadi tanggung jawab Anda untuk menindaklanjuti dengan pengelola terkait masalah pembayaran apa pun.",
  This_is_a_preview_of_what_users_will_see:
    "Ini adalah pratinjau dari apa yang akan dilihat pengguna saat mencoba mengaktifkan perangkat Anda. Perlu dicatat bahwa informasi rencana pembayaran hanya untuk tujuan tampilan.",
  Management_Information: "Informasi Manajemen",
  Manager: "Manajer",
  Phone: "Telepon",
  Additional_Information: "Informasi Tambahan",
  Low_Wallet_Balance_Warning: "Peringatan Saldo Dompet Rendah",
  Wallet_Amount: "Saldo Dompet",
  Your_charging_session_will_get_interrupted: "Sesi pengisian daya Anda akan terhenti jika saldo Anda tidak mencukupi.",
  Top_Up_Now: "Isi Saldo Sekarang",
  Deposit: "Setoran",
  PaypalFeeMessage: "Setoran dikenakan biaya transaksi dan pemrosesan PayPal. Klik",
  HERE: "DISINI",
  for_more_information: "untuk informasi lebih lanjut",
  Next: "Lanjut",
  Continue: "Lanjutkan",
  NonPaypalFeeMessage: "Setoran mungkin dikenakan biaya transaksi dan pemrosesan.",
  Payment_plan_currency_is_invalid: "Mata uang pada rencana pembayaran tidak valid. Silakan hubungi manajer perangkat atau dukungan pelanggan.",
  Error_no_payment_plan_assigned: "Kesalahan: Tidak ada rencana pembayaran yang ditetapkan",
  The_device_does_not_need_activation: "Perangkat ini tidak memerlukan aktivasi. Cukup colokkan dan langsung gunakan!",
  Pricing: "Harga",
  Pricing_Detail: "Rincian Harga",
  Default_Billing: "Tagihan Utama",
  Device_is: "Perangkat",
  disabled: "dinonaktifkan",
  by_default: "secara default",
  Device_is_disabled_during_this_time_period: "Perangkat dinonaktifkan selama periode waktu ini.",
  Sessions_will_automatically_terminate: "Sesi akan berakhir secara otomatis. Silakan hubungi manajemen untuk informasi lebih lanjut.",
  Activation: "Aktivasi",
  Add_Sub_Rule: "Tambah Sub Aturan",
  Edit: "Ubah",
  Delete: "Hapus",
  Move_Up: "Pindah Ke Atas",
  Move_Down: "Pindah ke Bawah",
  Add_new_conditional_rule: "Tambahkan aturan kondisional baru",
  Delete_Time_Based_Rule: "Hapus Aturan Berdasarkan Waktu",
  Deleting_this_rule_will_also_delete_all_sub_rule: "Menghapus aturan ini juga akan menghapus semua sub-aturan. Harap konfirmasi jika Anda ingin melanjutkan.",
  the_value_should_not_be_the_same: "nilai tidak boleh sama",
  Sunday: "Minggu",
  Monday: "Senin",
  Tuesday: "Selasa",
  Wednesday: "Rabu",
  Thursday: "Kamis",
  Friday: "Jumat",
  Saturday: "Sabtu",
  January: "Januari",
  February: "Februari",
  March: "Maret",
  April: "April",
  May: "Mei",
  June: "Juni",
  July: "Juli",
  August: "Agustus",
  September: "September",
  October: "Oktober",
  November: "November",
  December: "Desember",
  at: "pada",
  Manual_Topup: "Isi Saldo Manual",
  Wallet_balance_updated_successfully: "Saldo dompet berhasil diperbarui",
  Withdraw: "Tarik Dana",

  // Payment Plan Translations
  "For_the_first_{amount}_kwh_of_electricity_consumed": "Untuk {amount} kWh pertama dari listrik yang dikonsumsi",
  "Between_{min}_kwh_and_{max}_kwh_of_electricity_consumed": "Antara {min} kWh dan {max} kWh dari listrik yang dikonsumsi",
  "For_more_than_{amount}_kwh_of_electricity_consumed": "Untuk konsumsi listrik lebih dari {amount} kWh",
  "For_the_first_{duration}_of_the_session": "Untuk {duration} pertama dari sesi",
  "Between_session_duration_of_{min}_and_{max}": "Antara durasi sesi {min} dan {max}",
  "For_session_duration_longer_than_{duration}": "Untuk sesi dengan durasi lebih dari {duration}",
  "Every_year_for_calendar_days_between_{from}_and_{to}_with_html":
    'Setiap tahun untuk <b class="text-plugzio">hari kalender</b> antara <b class="text-plugzio">{from}</b> dan <b class="text-plugzio">{to}</b>',
  "Every_week_from_{from}_to_{to}": "Setiap minggu dari {from} hingga {to}",
  "{day}_of_the_week": "{day} dalam seminggu",
  "Every_day_for_time_of_day_between_{from}_and_{to}_with_html":
    'Setiap hari untuk <b class="text-plugzio">waktu</b> antara <b class="text-plugzio">{from}</b> dan <b class="text-plugzio">{to}</b>',

  // Payment Plan Translations
  "I_would_like_to_<strong>disable</strong>_the_device.": ", Saya ingin <strong>menonaktifkan</strong> perangkat.",
  "I_would_like_to_charge_users...": ", Saya ingin menagih pengguna...",
  "the_device_will_be_<strong>disable</strong>.": ", perangkat akan <strong>dinonaktifkan</strong>.",
  "you_will_be_billed...": ", Anda akan dikenakan biaya...",

  Pricing_in_next: "Harga untuk {n} ke depan",
  See_detail: "Lihat detail",

  Login_to_activate_a_device_monitor_usage_and_access_your_wallet: "Masuk untuk mengaktifkan perangkat, memantau penggunaan, dan mengakses dompet Anda",
  Please_agree_to_Plugzio_Terms_of_Service_and_Privacy_Policy_below_to_continue: "Harap setujui Syarat Layanan dan Kebijakan Privasi Plugzio di bawah ini untuk melanjutkan",
  I_have_read_and_agreed_to: "Saya telah membaca dan menyetujui",
  Terms_of_Service: "Syarat Layanan",
  Privacy_Policy: "Kebijakan Privasi",
  Disagree: "Tidak setuju",
  Agree: "Setuju",
  Back_to_Login: "Kembali ke Login",

  Unplug_from_charger_to_end_charging_session: "Cabut dari pengisi daya untuk mengakhiri sesi pengisian daya",
  You_have_an_ongoing_session_in_this_currency: "Anda memiliki sesi yang sedang berlangsung dalam mata uang {currency}, hanya satu sesi yang diizinkan per mata uang",
  You_currently_have_ongoing_session: "Anda sedang memiliki sesi yang sedang berlangsung",
  Please_end_current_session_before_starting_a_new_session: "Harap akhiri sesi saat ini sebelum memulai sesi baru",
  Ongoing_Session_Exist: "Ada Sesi yang Sedang Berlangsung",
  Unable_to_end_session_would_you_like_to_start_a_new_session_as_a_new_guest: "Tidak dapat mengakhiri sesi, apakah Anda ingin memulai sesi baru sebagai tamu baru?",
  Start_new_guest_session: "Mulai sesi tamu baru",
  Done: "Selesai",
  Session_Summary: "Ringkasan Sesi",
  Total_Cost: "Total Biaya",
  Total_Consumption: "Total Konsumsi",
  Total_Duration: "Total Durasi",
  Send_Receipt: "Kirim Tanda Terima",
  Get_Receipt: "Dapatkan Tanda Terima",
  Fill_out_the_Get_Receipt_form_below_to_receive_your_receipt_via_email: 'Isi formulir "Dapatkan Tanda Terima" di bawah ini untuk menerima tanda terima Anda melalui e-mail.',
  Your_receipt_is_emailed_to_email: "Tanda terima Anda telah dikirim melalui e-mail ke <strong>{email}</strong>",
  Session_ID: "ID Sesi",
  Start_Time: "Waktu Mulai",
  End_Time: "Waktu Berakhir",
  Device_is_using_INR_currency_guest_not_supported:
    "Perangkat menggunakan mata uang INR, yang tidak didukung untuk pengguna tamu. Daftarkan akun untuk melanjutkan atau menggunakan perangkat lain.",
  Continue_as_guest: "Lanjutkan sebagai tamu",
  Sign_in: "Masuk",
  Payment_Plan: "Rencana Pembayaran",
  Show_Full_Payment_Plan: "Tampilkan Rencana Pembayaran Penuh",
  LEARN_MORE: "PELAJARI LEBIH LANJUT",
  To_start_new_charging_session_please_end_your_current_ongoing_session_click_to_learn_more:
    "Untuk memulai sesi pengisian daya baru, silakan akhiri sesi Anda yang sedang berlangsung. Jika Anda ingin memulai beberapa sesi bersamaan, silakan buat akun Plugzio. Klik di sini untuk",
  Sign_up_for_an_account: "Daftar akun",
  Sign_up_for_an_account_to_access_the_following_features: "Daftar akun untuk mengakses fitur-fitur berikut",
  Easy_activation_by_saving_devices_to_your_favorites_list: "Aktivasi mudah dengan menyimpan perangkat ke daftar favorit Anda",
  No_need_to_top_up_every_time_with_the_use_of_Plugzio_wallets: "Tidak perlu mengisi ulang setiap saat dengan menggunakan dompet Plugzio",
  Track_electrical_consumption_charging_duration_and_total_cost_over_over_time: "Lacak konsumsi listrik, durasi pengisian daya, dan total biaya dari waktu ke waktu",
  Monitor_and_control_your_charging_sessions_across_multiple_devices: "Pantau dan kendalikan sesi pengisian daya Anda di beberapa perangkat",
  Remote_stop_charging_sessions_from_your_account: "Hentikan sesi pengisian daya dari jarak jauh dari akun Anda",
  Ability_to_start_multiple_and_concurrent_charging_sessions: "Kemampuan untuk memulai beberapa sesi pengisian daya secara bersamaan",
  Get_email_notifications_about_your_charging_sessions: "Dapatkan notifikasi email tentang sesi pengisian daya Anda",
  Select_payment_method: "Pilih metode pembayaran",
  Transaction_holding_fees_may_apply: "Biaya transaksi & penahanan mungkin berlaku untuk sesi pengisian daya Anda",
  Transaction_holding_fee_number_will_apply: "Biaya transaksi & penahanan sebesar {fee} akan berlaku untuk sesi pengisian daya Anda",
  When_paying_with_debit_or_credit_email:
    "Saat membayar menggunakan debit atau kredit, memasukkan e-mail pribadi bersifat opsional untuk menerima e-struk. Jika Anda tidak ingin memasukkan e-mail pribadi, cukup masukkan {email}",

  Sign_up_for_an_account_to_save_on_holding_fees: "Daftar akun untuk menghemat biaya penahanan.",
  Version: "Versi",
  Force_Lowercase: "Paksa Huruf Kecil",
  A_100_hold_will_be_placed_on_your_card:
    "Penahanan $100 akan dikenakan pada kartu Anda. Di akhir sesi penagihan, Anda akan ditagih sejumlah biaya sesi dan saldo penahanan akan otomatis dilepaskan dalam waktu 72 jam untuk memastikan transaksi diproses dengan benar.",
  Property_Name: "Nama Properti",
  Address_Line: "Baris Alamat",
  City: "Kota",
  State: "Negara Bagian",
  Province: "Provinsi",
  Zip_or_Postal_Code: "Kode_Zip",
  Country: "Negara",
  Location: "Lokasi",
  Device_Info: "Info Perangkat",
  Company_or_Manager_Name: "Nama Perusahaan/Manajer",
  General_Information: "Informasi Umum",
  Location_Information: "Informasi Lokasi",
  Address: "Alamat",
  Zip_Code: "Kode Pos",
  Subscription_Information: "Informasi Berlangganan",
  Registration_Date: "Tanggal Pendaftaran",
  Expiry_Date: "Tanggal Kedaluwarsa",
  Remaining_Days: "Sisa Hari",
  Auto_Payment: "Pembayaran Otomatis",
  Subscription_Model: "Model Berlangganan",
  Device_Information: "Informasi Perangkat",
  Session_Details: "Detail Sesi",
};
